import { BackOfficeRfidBadgeOrderModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/rfid-badge-orders/back-office-rfid-badge-order.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoRfidBadgeOrderListBillingAddressFullNameCell } from './emsp-bo-rfid-badge-order-list-billing-address-full-name.cell';
import { EmspBoRfidBadgeOrderListBillingAddressFullNameHeader } from './emsp-bo-rfid-badge-order-list-billing-address-full-name.header';

export const EmspBoRfidBadgeOrderListBillingAddressFullNameColumn: IdentifiedColumnDef<
  BackOfficeRfidBadgeOrderModel,
  BackOfficeRfidBadgeOrderModel['billingAddress']
> = {
  enableSorting: false,
  header: EmspBoRfidBadgeOrderListBillingAddressFullNameHeader,
  cell: EmspBoRfidBadgeOrderListBillingAddressFullNameCell,
};
